// src/app/components/shared/toaster.tsx
//
// -- Migrated onto the kit, Phase 6 ------------------------------------------
//
// This replaces `components/ui/sonner.tsx`.
//
// Sonner is the TRANSPORT, and it stays. Thirty-one files call `toast()`
// imperatively — from a catch block, from a websocket handler, from a save
// that finished after the component unmounted — and the kit's `ToastRegion`
// is a rendered region that takes a list. Swapping them is a plumbing change
// across thirty-one files, and this rebuild is presentation only.
//
// What moved is the presentation: the box is painted from tokens — 360 wide,
// pad 16, radius 12, gap 12, at --z-toast, every value the same one `.k-toast`
// uses. Recorded in design/MISSING.md.
//
// PLACEMENT IS NOT CHANGED. The kit's default is bottom right (DECISIONS.md
// D34) and the product mounts this with `position="top-right"`. That prop is
// spread last and therefore still wins. UPM-T15 is open and is the reviewer's,
// and a toast that silently moves to the other corner of every screen is
// exactly the kind of change a presentation-only rebuild should not make on
// its own.
//
// Two defects the swap removed:
//
//   * It read the theme from `next-themes`, which this app does not use.
//     There is no `next-themes` provider anywhere in the tree, so `useTheme()`
//     returned its default and every toast was rendered in "system" theme
//     regardless of what the user had chosen. It reads the app's own
//     ThemeContext now.
//   * It painted `--popover`, `--foreground` and `--border`, three quarantined
//     legacy names.
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useTheme } from "@/app/contexts/theme-context";
import "@/styles/toaster.css";

export function Toaster(props: ToasterProps) {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      className="upm-toaster"
      /* `props` is spread AFTER, so a caller's placement wins. */
      toastOptions={{ className: "upm-toast" }}
      {...props}
    />
  );
}
